import React from "react";
import { Box, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ThriveModal from "../../../common/ThriveModal";

const MAGENTA = "#9E1F63FF";

interface ReportModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  /** Shown behind the content until it paints over it (a PDF being built). */
  placeholder?: string;
  children: React.ReactNode;
}

/**
 * The Program Statistics dialog frame: a 1280 px ThriveModal under the magenta
 * title bar the old page's reports had. Like those, it closes from its own
 * button only — a stray backdrop click must not throw away a rendered PDF.
 */
const ReportModal: React.FC<ReportModalProps> = ({
  open,
  onClose,
  title,
  placeholder,
  children,
}) => (
  <ThriveModal
    width={1280}
    open={open}
    setOpen={(next: boolean) => {
      if (!next) onClose();
    }}
    contentComponent={
      <Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            backgroundColor: MAGENTA,
            color: "white",
            p: "3px",
            borderRadius: "5px 5px 0 0",
            mb: "20px",
          }}
        >
          {/* Balances the close button so the title stays centred. */}
          <Box sx={{ width: 46, flexShrink: 0 }} />
          <Typography
            variant="h4"
            component="h2"
            sx={{
              flex: 1,
              minWidth: 0,
              textAlign: "center",
              overflowWrap: "anywhere",
              fontSize: { xs: "1.25rem", sm: "2.125rem" },
            }}
          >
            {title}
          </Typography>
          <IconButton
            aria-label="Close"
            onClick={onClose}
            sx={{ color: "white", p: "3px" }}
          >
            <CloseIcon sx={{ fontSize: 40 }} />
          </IconButton>
        </Box>
        <Box sx={{ position: "relative" }}>
          {placeholder && (
            <Typography
              sx={{
                position: "absolute",
                top: 24,
                left: 0,
                right: 0,
                textAlign: "center",
                color: "#8a8a93",
              }}
            >
              {placeholder}
            </Typography>
          )}
          <Box sx={{ position: "relative" }}>{children}</Box>
        </Box>
      </Box>
    }
  />
);

export default ReportModal;
